import { formatDateRange } from "utils";

const OvertimeWorkflowCard = ({ workflow }) => {
    const {
        duration_string,
        ots_date_from,
    } = workflow;

    return (
        <>
            <div className="flex items-center justify-between p-3 rounded-xl bg-orange-50 border border-orange-200 dark:bg-orange-50/20">
                <span className="text-[12px] font-semibold text-slate-700 dark:text-orange-200">
                    Overtime Hours
                </span>

                <span className="text-[18px] font-bold text-orange-600 dark:text-orange-400">
                    {duration_string}
                </span>
            </div>

            <div className="p-2 rounded-lg bg-slate-50 border min-w-0 dark-mode-card">
                <span className="text-[10px] text-slate-700 font-semibold uppercase dark:text-slate-200">
                    Date
                </span>

                <p className="text-[12px] font-semibold truncate dark:text-white">
                    {formatDateRange(ots_date_from)}
                </p>
            </div>
        </>
    );
};

export default OvertimeWorkflowCard;